var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCouple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.27 5.46a3.37 3.37 0 0 0 3.28 3.46c1.8 0 3.27-1.55 3.27-3.46A3.37 3.37 0 0 0 13.55 2a3.37 3.37 0 0 0-3.28 3.46Zm-7.09 0a3.37 3.37 0 0 0 3.27 3.46 3.38 3.38 0 0 0 3.28-3.46A3.37 3.37 0 0 0 6.45 2a3.37 3.37 0 0 0-3.27 3.46ZM7.62 17a8.34 8.34 0 0 1 1.56-6.15 5.2 5.2 0 0 0-2.73-.77c-3 0-5.45 2.58-5.45 5.77V17h6.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.55 10.08c-3.02 0-5.46 2.58-5.46 5.77V17H19v-1.15c0-3.19-2.44-5.77-5.45-5.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCouple);
export default ForwardRef;